import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';

let scrollTimer = null;

function renderCont(isLoadingMore, hasMore, needGap) {
  if (isLoadingMore) {
    return <div className={s.loadText}>正在加载...</div>
  }
  return hasMore && needGap ?
    <div className={s.loadText}>&nbsp;</div> :
    <div className={s.loadText} />
}

class LoadMore extends React.Component {
  static propTypes = {
    onReachBottom: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    needGap: PropTypes.bool,
  };

  static defaultProps = {
    needGap: true,
  }

  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      isLoadingMore: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (scrollTimer) clearTimeout(scrollTimer)
    const { onReachBottom, hasMore } = this.props;
    const height = window.innerHeight
    const curPos = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop
                || 0
    const docLength = document.body.scrollHeight
    if (hasMore && !this.state.isLoadingMore && (curPos + height >= docLength - 100)) {
      scrollTimer = setTimeout(() => {
        this.setState({ isLoadingMore: true })
        onReachBottom().then(() => {
          this.setState({ isLoadingMore: false })
          clearTimeout(scrollTimer)
        })
      }, 300)
    }
  }
  render() {
    return (
      <div className={s.loadMore}>
        {renderCont(this.state.isLoadingMore, this.props.hasMore, this.props.needGap)}
      </div>
    );
  }
}

export default withStyles(s)(LoadMore);



// WEBPACK FOOTER //
// ./src/components/common/LoadMore/index.js